export const blockIconsActionLanguage = (
	<span className='material-symbols-outlined'>language</span>
);
